import { DOCUMENT } from '@angular/common';
import { Component, DestroyRef, inject, Inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { CloudMessagingService } from '@app/core/firebase/cloud-messaging/cloud-messaging.service';
import { TranslocoMissingHandlerController } from '@app/core/transloco/transloco-module.loader';
import { type Translation, TranslocoService } from '@ngneat/transloco';
import { environment } from 'environments/environment';
import { QuicklinkModule } from 'ngx-quicklink';
import { tap } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet, QuicklinkModule]
})
export class AppComponent implements OnInit {
  title: string = environment.TITLE;
  protected readonly messagingService: CloudMessagingService = inject(CloudMessagingService);
  protected readonly destroyRef: DestroyRef = inject(DestroyRef);
  protected readonly translocoService: TranslocoService = inject(TranslocoService);
  protected readonly translocoController: TranslocoMissingHandlerController = inject(TranslocoMissingHandlerController);
  protected readonly router: Router = inject(Router);
  protected readonly activatedRoute: ActivatedRoute = inject(ActivatedRoute);

  constructor(@Inject(DOCUMENT) private _document: Document) {
    window.document.title = `${this.title}`;
  }

  ngOnInit(): void {
    this.initTransloco();
    if ('serviceWorker' in navigator) {
      try {
        navigator.serviceWorker.register('/firebase-messaging-sw.js').then((registration) => {
          this.messagingService.registration = registration;
          this.messagingService.getFcmToken().then();
        });
      } catch (error) {
        console.warn('Service worker registration failed:', error);
      }
    }

    this._document.addEventListener('contextmenu', (event) => event.preventDefault());
  }

  protected initTransloco(): void {
    this.translocoController.event
      .pipe(
        tap(({ translation, lang }: { translation: Translation; lang: string }) => this.translocoService.setTranslation(translation, lang)),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe();
  }
}
